<template>
  <Modal :id="id" :title="modalTitle" :hideClose="true">
    <div slot="body" class="modal-body modal-form">
      <div class="row">
        <div class="col-12">
          <Field
            type="text"
            name="name"
            label="Topic Name"
            v-model="topic.name"
            validate="required"
            validate-as="Topic Name"
          />
        </div>
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-success" href="#" @click.prevent="save">Save</a>
      <a class="btn btn-info" href="#" @click.prevent="close">Cancel</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "edit-video-topic-modal",
      topic: { id: null, name: "" }
    };
  },
  computed: {
    modalTitle() {
      return !!this.topic.id ? "Edit Video Topic" : "Add New Video Topic";
    }
  },
  methods: {
    save() {
      if (!this.topic.name) {
        alert("Please enter a name for the topic before continuing.");
        return;
      }
      this.resolve(this.topic);
    }
  },
  mounted() {
    this.topic = _.clone(this.options.topic);
  }
};
</script>